import React from 'react'

import './news.less'

import {News} from '../../api/news'
import {getShortDateStr, ObsKeyToURL} from '../../api/utils'

interface Props {
  news: News
}

const NewsCard: React.FC<Props> = ({news}) => {
  return (
    <>
      <div className="news-card" onClick={() => window.open(news.url)}>
        <div
          className="news-image"
          style={{backgroundImage: `url(${ObsKeyToURL(news.image)})`}}
        >
          {/* <img className='hide' src={process.env.PUBLIC_URL + '/images/top-icon.png'}/> */}
        </div>
        <div className="news-info-group">
          <div className="news-title second-title">{news.title}</div>
          <div className="news-desc">{news.desc}</div>
          <div className="news-date small">{getShortDateStr(news.date)}</div>
        </div>
      </div>
    </>
  )
}

export default NewsCard
